{
  "loading": "Wczytywanie...",
  "loadingMore": "Wczytywanie większej liczby..."
}
